/**
 * Authentication endpoints
 */
export const AUTH_ENDPOINTS = {
  USER_VALIDATE: '/validate/',
  LEGACY_LOGIN: '/api-token-auth/',
  LOGIN: '/user-service/v1/auth',
  LEGACY_REFRESH: '/api-token-auth/refresh/',
  REFRESH: '/user-service/v1/auth/refresh-token',
  TOKEN_BLACKLIST: '/api-token-auth/blacklist/',
  LEGACY_RESET_PASSWORD: '/reset-password-update/',
  LEGACY_FORGOT_PASSWORD: '/reset-password/',
  FORGOT_PASSWORD: '/user-service/v1/forgot-password',
  CONFIRM_PASSWORD: '/user-service/v1/forgot-password/confirm-password',
  LOGOUT: '/user-service/v1/auth/logout',
  UPDATE_CREDENTIALS: '/auth/credentials/',
} as const;

export type AuthEndpoint = (typeof AUTH_ENDPOINTS)[keyof typeof AUTH_ENDPOINTS];
